<template>
    <div class="startegy-chart-info">
            <div class="chart-title">
                <p>
                    <span>机器学习多因子</span>
                </p>
            </div>
            <div class="myChart" id="myChart" ref="echarts"></div>
            <div class="strategy-info">
                <div>
                    <p>年化收益</p>
                    <p>17.7%</p>
                </div>
                <div>
                    <p>最大回撤</p>
                    <p>16.7%</p>
                </div>
                <div>
                    <p>初始资金</p>
                    <p>5000000</p>
                </div>
            </div>
            <div class="strategy-btn">
                <el-button type="info">应用</el-button>
            </div>
          </div>
</template>

<script>
export default {
    data: function () {
        return {

        }
    },
    mounted() {
        this.initEchart();
    },
    methods: {
        // 初始化 echart
        initEchart() {
            let chartNode = this.$refs.echarts;
            let mychart = this.$echarts.init(chartNode);
            let option = {
                // backgroundColor: '#394056',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: '#57617B'
                        }
                    }
                },
                legend: {
                    icon: 'rect',
                    itemWidth: 14,
                    itemHeight: 5,
                    itemGap: 13,
                    data: ['策略收益', '基准收益'],
                    textStyle: {
                        fontSize: 12,
                        color: '#F1F1F3'
                    }
                },
                grid: {
                    left: '5%',
                    right: '5%',
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#9d9d9d'
                        }
                    },
                    data: ['13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55'],
                }],
                yAxis: [{
                    type: 'value',
                    name: '累计收益%',
                    
                    axisTick: {
                        show: false
                    },
                    position: 'right',
                    axisLine: {
                        lineStyle: {
                            color: '#9d9d9d'
                        }
                    },
                    splitLine:{
                        show: true,
                        lineStyle: {
                            color: '#686869'
                        }
                    },
                    axisLabel: {
                        inside: true,
                    }
                }],
                series: [{
                    name: '策略收益',
                    type: 'line',
                    smooth: true,
                    symbolSize: 5,
                    showSymbol: false,
                    symbol: 'circle',
                    lineStyle: {
                        normal: {
                            width: 1
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(137, 189, 27, 0.3)'
                            },{
                                offset: 0.8,
                                color: 'rgba(137, 189, 27, 0)',
                            }], false),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(137,189,27)',
                            borderColor: 'rgba(137,189,2,0.27)',
                            borderWidth: 12
                        }
                    },
                    data: [0, 82, 191, 134, 150, 130, 140, 165, 175, 222, 195, 230]
                },{
                    name: '基准收益',
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',
                    symbolSize: 5,
                    showSymbol: false,
                    lineStyle: {
                        normal: {
                            width: 1
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0, 136, 212, 0.3)'
                            }, {
                                offset: 0.8,
                                color: 'rgba(0, 136, 212, 0)'
                            }], false),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(0,136,212)',
                            borderColor: 'rgba(0,136,212,0.2)',
                            borderWidth: 12
            
                        }
                    },
                    data: [0, 110, 125, 145, 122, 135, 122, 140, 152, 151, 134, 150] 
                }]
            };

            mychart.setOption(option);

            window.onresize = function() {
                mychart.resize();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .myChart{
        width: 100%;
        height: 250px;
    }
    .startegy-chart-info{
        background-color: #2d2d2f;
        width: 30%;
        margin: 20px auto;
        padding: 10px;
        border-radius: 5px;
        .chart-title{
            text-align: left;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
        }
        .strategy-info{
            display: flex;
            justify-content: space-between;
            width: 90%;
            margin: 0 auto;
            color: #858586;
            border-bottom: 1px solid #858586;
            padding: 5px;
            p{
                padding: 5px;
            }
        }
        .strategy-btn{
            text-align: right;
            padding: 15px;
        }
    }
</style>
